'use strict';

var util = angular.module('gymsystem.util');

util.directive('clockwidget', ['$interval', 'util', function($interval, util) {
    return {
        restrict: 'E',
        template: '<div style="font-weight: bold" ng-style="style">{{date.now() | date:settings.format}}</div>',
        scope: {
            settings: '='
        },
        link: function($scope) {
            $scope.date = Date;
            $scope.style = {
                'font-size': $scope.settings.font_size + 'px'
            };

            if (!util.isSmallScreen()) {
                $scope.style.position = 'absolute';
                $scope.style.left = '50%';
                $scope.style.top = '50%';
                $scope.style.transform =  'translate(-50%, -50%)';
            } else {
                $scope.style['margin-left'] = '10px';
            }

            $interval(function() {}, 1000);
        }
    };
}]);
